import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ICtoContract } from '../../../core/models/cto.model';

@Component({
  selector: 'tax-cto-info',
  templateUrl: './cto-info.component.html',
  styleUrls: ['./cto-info.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class CtoInfoComponent {
  // @ts-ignore
  @Input() contract: ICtoContract;
  // @ts-ignore
  isFullInfoVisible: boolean;

  constructor() {
  }

  // @ts-ignore
  getServicedModels(servicedModelsObject): Array<string> {
    return Object.values(servicedModelsObject);
  }
}
